import { Anchor, Stack, Text, Title } from '@mantine/core';
import { Trans, useTranslation } from 'react-i18next';
import Seo from '../../components/Seo.tsx';

const contactComponents = {
  email: <Anchor href="mailto:info@promonsa.com" aria-label="Email Promonsa" />,
};

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  const seoTitle = t('seo.privacyTitle');
  const seoDescription = t('seo.privacyDescription');

  const sections: Array<{ title: string; paragraphs: string[] }> = [
    {
      title: t('privacy.sections.introduction.title'),
      paragraphs: [
        'privacy.sections.introduction.p1',
        'privacy.sections.introduction.p2',
      ],
    },
    {
      title: t('privacy.sections.collection.title'),
      paragraphs: [
        'privacy.sections.collection.p1',
        'privacy.sections.collection.p2',
      ],
    },
    {
      title: t('privacy.sections.cookies.title'),
      paragraphs: [
        'privacy.sections.cookies.p1',
        'privacy.sections.cookies.p2',
      ],
    },
    {
      title: t('privacy.sections.links.title'),
      paragraphs: [
        'privacy.sections.links.p1',
      ],
    },
    {
      title: t('privacy.sections.security.title'),
      paragraphs: [
        'privacy.sections.security.p1',
      ],
    },
    {
      title: t('privacy.sections.changes.title'),
      paragraphs: [
        'privacy.sections.changes.p1',
      ],
    },
    {
      title: t('privacy.sections.contact.title'),
      paragraphs: [
        'privacy.sections.contact.p1',
        'privacy.sections.contact.p2',
        'privacy.sections.contact.p3',
        'privacy.sections.contact.p4',
      ],
    },
  ];

  return (
    <>
      <Seo title={seoTitle} description={seoDescription} canonicalPath="/privacy-policy" type="article" />
      <Stack gap="xl" py="xl">
        <Stack gap={4}>
          <Title order={1}>{t('privacy.title')}</Title>
          <Text c="dimmed">{t('privacy.lastUpdated')}</Text>
        </Stack>

        <Stack gap="xl">
          {sections.map((section) => (
            <Stack key={section.title} gap="sm">
              <Title order={3}>{section.title}</Title>
              <Stack gap="xs">
                {section.paragraphs.map((paragraphKey) => (
                  <Text key={paragraphKey}>
                    <Trans i18nKey={paragraphKey} components={contactComponents} />
                  </Text>
                ))}
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </>
  );
}
